import React, { useContext } from "react"
import { Box, BoxProps } from "@mui/material"
import TableStyleContext from "../TableStyleContext"

type Props = BoxProps & {
  role?: "cell" | "columnheader"
  "aria-sort"?: "none" | "ascending" | "descending"
  onClick?: React.MouseEventHandler<HTMLDivElement>
  className?: string
  style?: React.CSSProperties
  colSpan?: number
  rowSpan?: number
  "data-automation-id"?: string
  children?: React.ReactNode
}

const TableCell: React.FC<Props> = ({
  role = "cell",
  "aria-sort": ariaSort,
  onClick,
  children,
  className,
  style,
  colSpan,
  rowSpan,
  "data-automation-id": dataAutomationId,
  ...rest
}) => {
  const { cx, classes } = useContext(TableStyleContext)

  return (
    <Box
      role={role}
      aria-sort={ariaSort}
      aria-colspan={colSpan}
      aria-rowspan={rowSpan}
      className={cx(classes.tableCell, className)}
      onClick={onClick}
      style={style}
      data-automation-id={dataAutomationId}
      {...rest}
    >
      {children}
    </Box>
  )
}

export default TableCell
